
// GET
export const GET_USAGE_HISTORY_REQUEST = "GET_USAGE_HISTORY_REQUEST";
export const GET_USAGE_HISTORY_SUCCESS = "GET_USAGE_HISTORY_SUCCESS";
export const GET_USAGE_HISTORY_FAILURE = "GET_USAGE_HISTORY_FAILURE";

// CREATE
export const CREATE_USAGE_HISTORY_REQUEST = "CREATE_USAGE_HISTORY_REQUEST";
export const CREATE_USAGE_HISTORY_SUCCESS = "CREATE_USAGE_HISTORY_SUCCESS";
export const CREATE_USAGE_HISTORY_FAILURE = "CREATE_USAGE_HISTORY_FAILURE";

// EDIT
export const EDIT_USAGE_HISTORY_REQUEST = "EDIT_USAGE_HISTORY_REQUEST";
export const EDIT_USAGE_HISTORY_SUCCESS = "EDIT_USAGE_HISTORY_SUCCESS";
export const EDIT_USAGE_HISTORY_FAILURE = "EDIT_USAGE_HISTORY_FAILURE";

// DELETE
export const DELETE_USAGE_HISTORY_REQUEST = "DELETE_USAGE_HISTORY_REQUEST";
export const DELETE_USAGE_HISTORY_SUCCESS = "DELETE_USAGE_HISTORY_SUCCESS";
export const DELETE_USAGE_HISTORY_FAILURE = "DELETE_USAGE_HISTORY_FAILURE";